// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"ClientIcons_fadeIn__1eBNy","iconWrapper":"ClientIcons_iconWrapper__LbKF5","clientIcon":"ClientIcons_clientIcon__1b1Vb"};